import { fetchCurrentUser } from '../api';
import { calculateUserInfo } from './user-info';
import { Env } from '@/shared/config/environment';
import { USER_TYPE } from '@/shared/config/user-type';

const state = {
  currentUser: null,
  isLoadingUser: false,
  userError: null,
};

const mutations = {
  SET_CURRENT_USER(state, user) {
    state.currentUser = user;
  },
  SET_LOADING_USER(state, isLoading) {
    state.isLoadingUser = isLoading;
  },
  SET_USER_ERROR(state, error) {
    state.userError = error;
  },
};

const actions = {
  async loadCurrentUser({ commit, dispatch }) {
    commit('SET_LOADING_USER', true);
    commit('SET_USER_ERROR', null);
    dispatch('accountBonusesModule/setLoadingBonuses', true, { root: true });

    try {
      const user = await fetchCurrentUser();
      commit('SET_CURRENT_USER', user);

      dispatch('accountBonusesModule/setBonuses', user?.bonusSystemBalance || 0, { root: true });
      dispatch('accountBonusesModule/setLoadingBonuses', false, { root: true });

      return user;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Помилка при отриманні даних користувача';

      commit('SET_USER_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося отримати дані користувача',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_USER', false);
    }
  },
};

const getters = {
  isUserDataLoading: state => state.isLoadingUser,
  isUserDataReady: state => Boolean(!state.isLoadingUser && state.currentUser),
  isMainPartner: state => state?.currentUser?.parentId === null,
  isNeedOnboarding: state => state?.currentUser?.isNeedOnboarding,
  isUnderReview: state => state?.currentUser?.isUnderReview,
  onboardingInfo: state => state?.currentUser?.onboardingInfo,
  isBankPartner: state => Number(state?.currentUser?.type_id) === USER_TYPE.BANK,
  isApiPartner: state => Number(state?.currentUser?.type_id) === USER_TYPE.API,
  userError: state => state.userError,
  getCurrentUser: state => state.currentUser,
  getUserLevelId: state => state.currentUser?.levelId ?? null,
  getCurrentUserId: state => state.currentUser ? state.currentUser.id : null,
  getParentId: state => state.currentUser?.userInfo?.parentId,
  getRecipientType: state => state.currentUser?.userInfo?.recipientTypeId,
  getUserInfo: state => calculateUserInfo(state.currentUser),

  getRecipientAccount: state => state.currentUser?.userInfo?.recipientAccount ?? null,
  getRecipientBankName: state => state.currentUser?.userInfo?.recipientBankName ?? null,
  getRecipientCode: state => state.currentUser?.userInfo?.recipientCode ?? null,
  getRecipientName: state => state.currentUser?.userInfo?.recipientName ?? null,
  getRecipientBankCard: state => state.currentUser?.userInfo?.recipientBankCard ?? null,

  getPeriodsActsGenerate: state => state.currentUser?.userInfo?.periodActsGenerateId || 30,

  getDiscountLimitThreshold: state => state?.currentUser?.discountLimitThreshold || 0,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
